export default "dist/images/components-image-shape-control-blob1.3c54e8e.png";